module.exports = __webpack_public_path__ + "static/_/src/config/PsMusicConfig/musics/cd1//Track_29_Story_8_I_Love_Pets.mp3";